"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHighlighted = exports.IconButton = exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const utils_1 = require("../lib/utils");
const theme_1 = __importDefault(require("../styles/theme"));
/**
 * Renders an icon from the Material icons library.
 * Specify the name of the icon as the `name` prop.
 */
const Icon = (_a) => {
    var { className = '', color = theme_1.default.colors.primaryAccent, name, size = '20px', style } = _a, commonProps = __rest(_a, ["className", "color", "name", "size", "style"]);
    return (react_1.default.createElement("i", Object.assign({}, commonProps, { "data-testid": `${name}-icon`, className: `material-icons ${className}`, style: Object.assign({ fontSize: size, fontFeatureSettings: '"liga" 1', color, maxWidth: size, maxHeight: size }, style) }), name));
};
exports.Icon = Icon;
const StyledIcon = styled_components_1.default.i `
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
`;
const IconButton = ({ className = '', color = theme_1.default.colors.primaryAccent, name, size = '20px', onClick = utils_1.noop, disabled = false, ariaLabel, ariaPressed = false, }) => (react_1.default.createElement(StyledIcon, { "aria-label": ariaLabel, "aria-pressed": ariaPressed, "data-testid": `${name}-icon`, className: `material-icons ${className}`, onClick: disabled ? utils_1.noop : onClick, onKeyPress: (e) => {
        if (!disabled && e.key === 'Enter') {
            onClick(e);
        }
    }, role: "button", tabIndex: 0, style: {
        fontSize: size,
        fontFeatureSettings: '"liga" 1',
        color: disabled ? theme_1.default.colors.textInactive : color,
        maxWidth: size,
        maxHeight: size,
    }, disabled: disabled }, name));
exports.IconButton = IconButton;
const StyledIconHighlighted = styled_components_1.default.div `
  background: ${(props) => props.backgroundColor};
  border-radius: 50%;
  display: inline-flex;
  padding: 8px;
  line-height: 1;
`;
const IconHighlighted = (_a) => {
    var { className = '', color = theme_1.default.colors.primaryAccent, name, size = '20px', backgroundColor = 'none' } = _a, commonProps = __rest(_a, ["className", "color", "name", "size", "backgroundColor"]);
    return (react_1.default.createElement(StyledIconHighlighted, Object.assign({ backgroundColor: backgroundColor }, commonProps),
        react_1.default.createElement("i", { "data-testid": `${name}-icon`, className: `material-icons ${className}`, style: {
                fontSize: size,
                fontFeatureSettings: '"liga" 1',
                color,
                maxWidth: size,
                maxHeight: size,
            } }, name)));
};
exports.IconHighlighted = IconHighlighted;
exports.default = exports.Icon;
